import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'
import { LayoutPlugin } from 'bootstrap-vue'
import { CardPlugin } from 'bootstrap-vue'
import { VBScrollspyPlugin } from 'bootstrap-vue'
import { DropdownPlugin, TablePlugin } from 'bootstrap-vue'
import { BNav } from 'bootstrap-vue'
import { NavPlugin } from 'bootstrap-vue'
import { BNavbar } from 'bootstrap-vue'
import { BToast } from 'bootstrap-vue'
import VueSession from 'vue-session'
import VModal from 'vue-js-modal'
import store from './store'
import { MonthPicker } from 'vue-month-picker'
import { MonthPickerInput } from 'vue-month-picker'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/css/main.css'
import dotenv from 'dotenv'
import './assets/kelson/stylesheet.css'
dotenv.config()

Vue.use(VueSession)
Vue.use(VModal, { dialog: true })

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(LayoutPlugin)
Vue.use(ModalPlugin)
Vue.use(CardPlugin)
Vue.use(VBScrollspyPlugin)
Vue.use(DropdownPlugin)
Vue.use(TablePlugin)
Vue.use(NavPlugin)
Vue.use(MonthPicker)
Vue.use(MonthPickerInput)
Vue.component('b-nav', BNav)
Vue.component('b-navbar', BNavbar)
Vue.component('b-toast', BToast)

new Vue({
  router,
  store,
  render: h => h(App),
  beforeCreate() {
    this.$store.dispatch('auth/init');
  },
  created() {
    const token = this.$store.getters['auth/token'];
    const user = this.$store.getters['auth/user'];
    
    if (token && user) {
      if(new Date() > new Date(token.expires * 1000)) {
        this.$router.push({ name : 'login' }).catch(()=>{});
      }else{
        setTimeout(()=>{
          this.$router.push({ name: 'login', params: {
            message: "Conecte-se novamente",
            body: {
              title: "Sessão expirada",
              variant: "danger",
              solid: true,
            }
          }});
        }, new Date(token.expires*1000) - new Date());
        if (this.$route.name === 'login') {
          this.$router.push({ name: 'home'}).catch(()=>{});
        }
      }
    } else {
      // Rotas públicas (acessíveis sem login): landing, login e resetPassword.
      const publicPaths = ['/', '/login'];
      const isPublic = publicPaths.includes(this.$route.path)
        || this.$route.path.includes('resetPassword/');
      if (!isPublic)
        this.$router.push({ name: 'root' }).catch(()=>{});
    }
  }
}).$mount('#app')
